import {
	ThemeColorVariable,
	ThemeFontSizeVariable,
	ThemeFontVariable,
	ThemeRadiusVariable,
	ThemeShadowVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
// eslint-disable-next-line import/no-named-as-default
import styled from "styled-components";

export const StyledPopoverTrigger = styled.span`
	cursor: pointer;
`;

export const StyledPopover = styled.div`
	background-color: ${ThemeColorVariable.OnSurface};
	border-radius: ${ThemeRadiusVariable.Medium};
	box-shadow: ${ThemeShadowVariable.Medium};
	color: ${ThemeColorVariable.Surface};
	font-family: ${ThemeFontVariable.Body};
	font-size: ${ThemeFontSizeVariable.Medium};
	max-width: 260px;
	min-width: 160px;
	padding: ${ThemeSpaceVariable.Medium};
	z-index: 9999;

	> * {
		/* Limit content max width further to avoid collision with close button. */
		max-width: calc(100% - 20px);
	}

	#arrow,
	#arrow::before {
		background: ${ThemeColorVariable.OnSurface};
		height: 8px;
		position: absolute;
		width: 8px;
	}

	#arrow {
		visibility: hidden;
	}

	#arrow::before {
		content: "";
		transform: rotate(45deg);
		visibility: visible;
	}

	&[data-popper-placement^="top"] > #arrow {
		bottom: -4px;

		&::before {
			box-shadow: 1px 1px 1px 0 rgb(0 0 0 / 10%);
		}
	}

	&[data-popper-placement^="bottom"] > #arrow {
		top: -4px;

		&::before {
			box-shadow: -1px -1px 1px 0 rgb(0 0 0 / 10%);
		}
	}

	&[data-popper-placement^="left"] > #arrow {
		right: -4px;

		&::before {
			box-shadow: 1px -1px 1px 0 rgb(0 0 0 / 10%);
		}
	}

	&[data-popper-placement^="right"] > #arrow {
		left: -4px;

		&::before {
			box-shadow: -1px 1px 1px 0 rgb(0 0 0 / 10%);
		}
	}

	#popover-closebutton {
		background-color: transparent;
		border: unset;
		border-radius: 0;
		box-shadow: unset;
		height: unset;
		min-width: unset;
		padding: ${ThemeSpaceVariable.Small};
		position: absolute;
		right: ${ThemeSpaceVariable.XSmall};
		top: ${ThemeSpaceVariable.XSmall};

		&:hover::after {
			background-color: transparent;
		}
	}
`;
